import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solution2',
  templateUrl: './solution2.component.html',
  styleUrls: ['./solution2.component.scss']
})
export class Solution2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
